export default __webpack_public_path__ + "static/media/daily-home.fe62e6b6.png";